import React from 'react';
import styled from 'styled-components';

const IconSheetContainer = styled.svg`
	display: none;
`;
// To add new: Copy icon as SVG, <svg> is replaced by <defs> below, add id (name) and viewBox
// Copy <path>(s) and make keys camel case instead of with -

const IconSheet = () => {
	return (
		<IconSheetContainer
			width="100%"
			height="100%"
			xmlns="http://www.w3.org/2000/svg"
		>
			<defs>
				<symbol
					id="icon-arrow"
					viewBox="0 0 10 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M8.48528 18.2132L4.71405 14.442L2.82843 12.5563C1.26633 10.9942 1.26633 8.46157 2.82843 6.89948L4.71405 5.01386L8.48528 1.24262"
						stroke="currentColor"
						strokeWidth="3"
					/>
				</symbol>
				<symbol
					id="icon-disabled"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M4.93018 4.92993L19.0702 19.0699"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
				<symbol
					id="icon-checkmark"
					viewBox="0 0 16 12"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M14.3549 1.56221L14.3628 1.57008L14.3709 1.57761C14.4217 1.62443 14.4622 1.68125 14.4899 1.7445C14.5176 1.80775 14.5319 1.87606 14.5319 1.94511C14.5319 2.01415 14.5176 2.08246 14.4899 2.14571C14.4622 2.20896 14.4217 2.26578 14.3709 2.3126L14.3635 2.31943L14.3564 2.32655L6.19639 10.4865L6.19495 10.488C6.14847 10.5349 6.09317 10.5721 6.03224 10.5975C5.97131 10.6228 5.90596 10.6359 5.83995 10.6359C5.77394 10.6359 5.70859 10.6228 5.64766 10.5975C5.58673 10.5721 5.53143 10.5349 5.48495 10.488L5.4835 10.4866L1.6435 6.64655L1.64356 6.6465L1.63733 6.64049C1.58804 6.59287 1.5486 6.53601 1.52128 6.47315C1.49396 6.41029 1.47929 6.34266 1.47811 6.27413C1.47692 6.2056 1.48924 6.13751 1.51437 6.07375C1.5395 6.00998 1.57695 5.95179 1.62457 5.90249C1.67219 5.85319 1.72905 5.81376 1.79191 5.78644C1.85477 5.75912 1.92239 5.74445 1.99092 5.74326C2.05945 5.74208 2.12754 5.7544 2.19131 5.77953C2.25385 5.80418 2.31103 5.84067 2.35972 5.88699L5.48583 9.02309L5.83962 9.37801L6.19374 9.02342L13.6437 1.56342L13.6449 1.56221C13.6914 1.51534 13.7467 1.47814 13.8077 1.45276C13.8686 1.42738 13.9339 1.41431 13.9999 1.41431C14.066 1.41431 14.1313 1.42738 14.1922 1.45276C14.2532 1.47814 14.3085 1.51534 14.3549 1.56221Z"
						fill="currentColor"
						stroke="currentColor"
					/>
				</symbol>
				<symbol
					id="icon-close"
					width="29"
					height="29"
					viewBox="0 0 29 29"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M1.0625 27.9375L27.9375 1.0625"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M1.0625 1.0625L27.9375 27.9375"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>

				<symbol
					id="icon-search"
					viewBox="0 0 42 42"
					fill="current"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle
						cx="21"
						cy="21.5"
						r="20"
						transform="rotate(-90 21 21.5)"
						stroke="current"
						strokeWidth="2"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M25.9744 22.3526C24.4282 25.9907 20.2255 27.6866 16.5874 26.1404C12.9492 24.5943 11.2534 20.3916 12.7995 16.7534C14.3457 13.1153 18.5484 11.4194 22.1865 12.9656C25.8247 14.5118 27.5205 18.7145 25.9744 22.3526Z"
						stroke="current"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M24.4478 24.6133L29.9998 30.1645"
						stroke="current"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>

			<defs>
				<symbol
					id="icon-language"
					width="100%"
					height="100%"
					viewBox="0 0 31 34"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M15.5 32.2895C23.5081 32.2895 30 25.2851 30 16.6447C30 8.00439 23.5081 1 15.5 1C7.49187 1 1 8.00439 1 16.6447C1 25.2851 7.49187 32.2895 15.5 32.2895Z"
						stroke="#FFA900"
						strokeWidth="1.8125"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M9.69883 16.6447C9.69883 25.2851 12.2956 32.2895 15.4988 32.2895C18.7021 32.2895 21.2988 25.2851 21.2988 16.6447C21.2988 8.00439 18.7021 1 15.4988 1C12.2956 1 9.69883 8.00439 9.69883 16.6447Z"
						stroke="#FFA900"
						strokeWidth="1.8125"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M1 16.645H30"
						stroke="#FFA900"
						strokeWidth="1.8125"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>

			<defs>
				<symbol
					id="icon-arrow-right"
					viewBox="0 0 8 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M1 13L7 7L0.999999 1"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>

			<defs>
				<symbol
					id="icon-facebook"
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16 0C7.1625 0 0 7.20613 0 16.0975C0 24.1336 5.85 30.7927 13.5 32V20.7506H9.4375V16.0975H13.5V12.551C13.5 8.51719 15.8875 6.28807 19.5438 6.28807C21.2938 6.28807 23.125 6.60248 23.125 6.60248V10.564H21.1063C19.1188 10.564 18.5 11.8059 18.5 13.0792V16.0975H22.9375L22.2281 20.7506H18.5V32C26.15 30.7927 32 24.1336 32 16.0975C32 7.20613 24.8375 0 16 0Z"
						fill="currentColor"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-linkedIn"
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M2.34481 0.00216805H29.4221V0.00020628C30.7044 -0.016705 31.758 1.00833 31.7763 2.29057V29.4822C31.7585 30.7651 30.705 31.7911 29.4221 31.775H2.34481C1.06446 31.7886 0.0150837 30.7625 0 29.4822V2.29254C0.0156184 1.01282 1.06508 -0.0122737 2.34481 0.00216805ZM4.33687 7.10744C4.33715 8.61643 5.56064 9.83948 7.06962 9.83921C7.79426 9.83908 8.48917 9.55109 9.00147 9.0386C9.51378 8.52611 9.80152 7.8311 9.80139 7.10646C9.80112 5.59748 8.57762 4.37443 7.06864 4.3747C5.55966 4.37497 4.3366 5.59846 4.33687 7.10744ZM22.3667 27.0748H27.0749L27.0769 18.7569C27.0769 14.6735 26.197 11.5347 21.425 11.5347C19.6007 11.467 17.8871 12.4081 16.9654 13.9839H16.9021V11.9118H12.3822V27.0743H17.0905V19.5735C17.0905 17.5956 17.4657 15.6799 19.9179 15.6799C22.3353 15.6799 22.3667 17.9433 22.3667 19.7015V27.0748ZM9.42385 27.0743H4.71071V11.9113H9.42385V27.0743Z"
						fill="currentColor"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-x"
					viewBox="0 0 1944 1944"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M1944 0H0v1944h1944V0Zm-411.11 359-446.73 519.284h-.02L1572 1585.37h-357.33l-327.179-476.15-409.625 476.15H372l468.492-544.55L372 359h357.328l309.812 450.887L1427.03 359h105.86ZM893.697 978.934l47.468 67.896v.02l323.315 462.45h162.6l-396.2-566.721-47.468-67.894-304.797-435.991H516.011l377.686 540.24Z"
						fill="currentColor"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-facebook"
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16 0C7.1625 0 0 7.20613 0 16.0975C0 24.1336 5.85 30.7927 13.5 32V20.7506H9.4375V16.0975H13.5V12.551C13.5 8.51719 15.8875 6.28807 19.5438 6.28807C21.2938 6.28807 23.125 6.60248 23.125 6.60248V10.564H21.1063C19.1188 10.564 18.5 11.8059 18.5 13.0792V16.0975H22.9375L22.2281 20.7506H18.5V32C26.15 30.7927 32 24.1336 32 16.0975C32 7.20613 24.8375 0 16 0Z"
						fill="currentColor"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-linkedIn"
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M2.34481 0.00216805H29.4221V0.00020628C30.7044 -0.016705 31.758 1.00833 31.7763 2.29057V29.4822C31.7585 30.7651 30.705 31.7911 29.4221 31.775H2.34481C1.06446 31.7886 0.0150837 30.7625 0 29.4822V2.29254C0.0156184 1.01282 1.06508 -0.0122737 2.34481 0.00216805ZM4.33687 7.10744C4.33715 8.61643 5.56064 9.83948 7.06962 9.83921C7.79426 9.83908 8.48917 9.55109 9.00147 9.0386C9.51378 8.52611 9.80152 7.8311 9.80139 7.10646C9.80112 5.59748 8.57762 4.37443 7.06864 4.3747C5.55966 4.37497 4.3366 5.59846 4.33687 7.10744ZM22.3667 27.0748H27.0749L27.0769 18.7569C27.0769 14.6735 26.197 11.5347 21.425 11.5347C19.6007 11.467 17.8871 12.4081 16.9654 13.9839H16.9021V11.9118H12.3822V27.0743H17.0905V19.5735C17.0905 17.5956 17.4657 15.6799 19.9179 15.6799C22.3353 15.6799 22.3667 17.9433 22.3667 19.7015V27.0748ZM9.42385 27.0743H4.71071V11.9113H9.42385V27.0743Z"
						fill="currentColor"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-logo"
					viewBox="0 0 242.242 147.941"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
				>
					<path id="a" d="M0 0h242.242v147.94H0z" />
					<clipPath id="b">
						<use xlinkHref="#a" overflow="visible" />
					</clipPath>
					<path
						clipPath="url(#b)"
						fill="currentColor"
						d="M.084 28.613c-.338 1.19.373 2.154 1.586 2.154H42.9c.606 0 1.098.503 1.098 1.123v113.807c0 1.24.984 2.244 2.2 2.244h28.266c1.213 0 2.198-1.003 2.198-2.243V31.89c0-.62.492-1.123 1.1-1.123h159.566c1.215 0 1.976-.977 1.702-2.185l-5.994-26.397C232.763.977 231.556 0 230.34 0H10.403C9.188 0 7.93.965 7.592 2.155L.084 28.613z"
					/>
					<path
						clipPath="url(#b)"
						fill="currentColor"
						d="M210.19 118.755c0 4.736-3.507 5.582-8.407 5.582-4.906 0-8.405-.846-8.405-5.582V74.58c0-4.74 3.5-5.584 8.405-5.584 4.9 0 8.406.843 8.406 5.583v44.175zm20.497-72.347h-57.81c-9.282 0-11.55 5.417-11.55 12.032v77.464c0 6.623 2.268 12.037 11.55 12.037h57.81c9.283 0 11.555-5.413 11.555-12.036V58.44c0-6.615-2.272-12.032-11.555-12.032M103.535 147.94h43.973c1.215 0 2.422-.978 2.694-2.188l4.698-20.457c.275-1.21-.487-2.188-1.7-2.188h-25.77c-3.233 0-3.394-2.066-3.394-5.44V76.68c0-3.373.16-5.44 3.395-5.44h23.77c1.213 0 1.975-.977 1.7-2.186l-4.698-20.46c-.272-1.207-1.48-2.187-2.694-2.187h-41.973c-9.287 0-11.554 5.414-11.554 12.033v77.464c0 6.623 2.268 12.037 11.555 12.037"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-minus"
					viewBox="0 0 18 3"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M18 2.57143H10.2857H7.71429H0V0H7.71429H10.2857H18V2.57143Z"
						fill="currentColor"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-plus"
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M18 10.2857H10.2857V18H7.71429V10.2857H0V7.71429H7.71429V0H10.2857V7.71429H18V10.2857Z"
						fill="currentColor"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-arrow-left"
					viewBox="0 0 8 14"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M7 1L1 7L7 13"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-arrow-up"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M27.75 23.125L18.5 13.875L9.25 23.125"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-arrow-down"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M9.25 13.875L18.5 23.125L27.75 13.875"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-phone"
					viewBox="0 0 24 25"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle cx="12" cy="12.5" r="12" fill="currentColor" />
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M14.3007 19.3624L14.3081 19.3668C15.6662 20.2314 17.4426 20.0366 18.581 18.8982L19.0614 18.4178C19.5082 17.9704 19.5082 17.2457 19.0614 16.7984L17.0373 14.7755C16.59 14.3288 15.8653 14.3288 15.4179 14.7755V14.7755C15.2034 14.9904 14.9122 15.1111 14.6086 15.1111C14.3049 15.1111 14.0137 14.9904 13.7992 14.7755L10.5604 11.5362C10.1136 11.0888 10.1136 10.3641 10.5604 9.91679V9.91679C10.7752 9.70222 10.896 9.41104 10.896 9.10741C10.896 8.80378 10.7752 8.5126 10.5604 8.29803L8.53697 6.2721C8.08962 5.82532 7.36493 5.82532 6.91759 6.2721L6.43717 6.75251C5.29901 7.89095 5.10396 9.66703 5.96793 11.0253L5.9729 11.0328C8.19088 14.3161 11.0178 17.1437 14.3007 19.3624V19.3624Z"
						stroke="white"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-mail"
					viewBox="0 0 26 27"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M13 25.5C19.6274 25.5 25 20.1274 25 13.5C25 6.87258 19.6274 1.5 13 1.5C6.37258 1.5 1 6.87258 1 13.5C1 20.1274 6.37258 25.5 13 25.5Z"
						fill="currentColor"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M6.25 9.75C6.25 8.92157 6.92157 8.25 7.75 8.25H18.25C19.0784 8.25 19.75 8.92157 19.75 9.75V17.25C19.75 18.0784 19.0784 18.75 18.25 18.75H7.75C6.92157 18.75 6.25 18.0784 6.25 17.25V9.75Z"
						stroke="white"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M6.25 9.75L13 13.5L19.75 9.75"
						stroke="white"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-instagram"
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M26.4617 7.46003C26.4617 6.39652 25.5998 5.53779 24.5402 5.53779C23.4806 5.53779 22.6179 6.39652 22.6179 7.46003C22.6179 8.51963 23.4806 9.37836 24.5402 9.37836C25.5998 9.37836 26.4617 8.51963 26.4617 7.46003"
						fill="currentColor"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M31.1563 5.5193C31.5556 6.53377 31.8245 7.69851 31.9027 9.40334C31.981 11.1089 32 11.6545 32 16.002C32 20.3455 31.981 20.8902 31.9027 22.5958C31.8245 24.2975 31.5556 25.4614 31.1563 26.4807C30.7499 27.5292 30.205 28.4251 29.3131 29.3131C28.4251 30.2011 27.5332 30.7499 26.4807 31.1602C25.4623 31.5556 24.3014 31.8245 22.5958 31.9027C20.8902 31.981 20.3455 32 15.998 32C11.6545 32 11.1058 31.981 9.4002 31.9027C7.69851 31.8245 6.53851 31.5556 5.51533 31.1602C4.46682 30.7499 3.57488 30.2011 2.68691 29.3131C1.79497 28.4251 1.25014 27.5292 0.839753 26.4807C0.44437 25.4614 0.175542 24.2975 0.0932862 22.5958C0.0189775 20.8902 0 20.3455 0 16.002C0 11.6545 0.0189775 11.1089 0.0932862 9.40334C0.175542 7.69851 0.44437 6.53377 0.839753 5.5193C1.25014 4.46682 1.79497 3.57488 2.68691 2.68294C3.57488 1.79497 4.46682 1.25014 5.51533 0.838982C6.53851 0.443598 7.69851 0.171566 9.4002 0.0972576C11.1058 0.0150032 11.6545 0 15.998 0C20.3455 0 20.8902 0.0150032 22.5958 0.0972576C24.3014 0.171566 25.4623 0.443598 26.4807 0.838982C27.5332 1.25014 28.4251 1.79497 29.3131 2.68294C30.205 3.57488 30.7499 4.46682 31.1563 5.5193ZM28.4733 25.4353C28.69 24.8723 28.9509 24.0247 29.0221 22.4646C29.1004 20.778 29.1193 20.2703 29.1193 16.002C29.1193 11.7249 29.1004 11.2212 29.0221 9.53457C28.9509 7.9745 28.69 7.12763 28.4733 6.55984C28.1823 5.81421 27.8352 5.28361 27.2722 4.72378C26.7155 4.16477 26.1818 3.8176 25.4353 3.52665C24.8724 3.30604 24.0215 3.04824 22.4614 2.97393C20.7748 2.89956 20.2751 2.88059 15.998 2.88059C11.7249 2.88059 11.2212 2.89956 9.53458 2.97393C7.97452 3.04824 7.12765 3.30604 6.56461 3.52665C5.81423 3.8176 5.28446 4.16477 4.72462 4.72378C4.16081 5.28361 3.8137 5.81421 3.52667 6.55984C3.30997 7.12763 3.04512 7.9745 2.97786 9.53457C2.89567 11.2212 2.88061 11.7249 2.88061 16.002C2.88061 20.2703 2.89567 20.778 2.97786 22.4646C3.04512 24.0247 3.30997 24.8723 3.52667 25.4353C3.8137 26.1818 4.16081 26.7155 4.72462 27.2754C5.28446 27.8352 5.81423 28.1815 6.56461 28.4693C7.12765 28.6892 7.97452 28.9509 9.53458 29.0253C11.2212 29.0996 11.7249 29.1154 15.998 29.1154C20.2751 29.1154 20.7748 29.0996 22.4614 29.0253C24.0215 28.9509 24.8724 28.6892 25.4353 28.4693C26.1818 28.1815 26.7155 27.8352 27.2722 27.2754C27.8352 26.7155 28.1823 26.1818 28.4733 25.4353Z"
						fill="currentColor"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M7.78479 16.0019C7.78479 11.4639 11.4601 7.78077 15.9981 7.78077C20.5361 7.78077 24.2153 11.4639 24.2153 16.0019C24.2153 20.536 20.5361 24.2153 15.9981 24.2153C11.4601 24.2153 7.78479 20.536 7.78479 16.0019ZM10.6654 16.0019C10.6654 18.9458 13.0542 21.3307 15.9981 21.3307C18.9428 21.3307 21.3347 18.9458 21.3347 16.0019C21.3347 13.0533 18.9428 10.6653 15.9981 10.6653C13.0542 10.6653 10.6654 13.0533 10.6654 16.0019Z"
						fill="currentColor"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-youtube"
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M18.6 16L14.4 13.6V18.4L18.6 16Z"
						fill="currentColor"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16ZM22.2 10.7C22.9 10.9 23.4 11.4 23.6 12.1C24 13.4 24 16 24 16C24 16 24 18.6 23.7 19.9C23.5 20.6 23 21.1 22.3 21.3C21 21.6 16 21.6 16 21.6C16 21.6 10.9 21.6 9.7 21.3C9 21.1 8.5 20.6 8.3 19.9C8 18.6 8 16 8 16C8 16 8 13.4 8.2 12.1C8.4 11.4 8.90001 10.9 9.60001 10.7C10.9 10.4 15.9 10.4 15.9 10.4C15.9 10.4 21 10.4 22.2 10.7Z"
						fill="currentColor"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-link"
					viewBox="0 0 46 45"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle cx="23" cy="22.5" r="22.5" fill="currentColor" />
					<path
						d="M16.5508 28.9485L29.4495 16.0498"
						stroke="white"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M17.761 22.5262C16.1982 22.4362 14.6712 23.0171 13.5634 24.1232L10.7994 26.8872C9.40291 28.2837 8.8575 30.3192 9.36867 32.2269C9.87983 34.1346 11.3699 35.6246 13.2776 36.1358C15.1853 36.647 17.2208 36.1016 18.6173 34.705L21.3813 31.941C22.4874 30.8333 23.0683 29.3062 22.9783 27.7434"
						stroke="white"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M28.2395 22.4709C29.8023 22.5608 31.3292 21.9799 32.4371 20.874L35.2011 18.1099C36.5976 16.7134 37.143 14.6779 36.6319 12.7703C36.1207 10.8626 34.6306 9.3725 32.7229 8.86134C30.8152 8.35018 28.7798 8.89558 27.3832 10.2921L24.6192 13.0561C23.5158 14.1652 22.9372 15.6919 23.0284 17.2537"
						stroke="white"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-loader"
					viewBox="0 0 120 30"
					fill="currentColor"
					xmlns="http://www.w3.org/2000/svg"
				>
					<circle cx="15" cy="15" r="15">
						<animate
							attributeName="r"
							from="15"
							to="15"
							begin="0s"
							dur="0.8s"
							values="15;9;15"
							calcMode="linear"
							repeatCount="indefinite"
						/>
						<animate
							attributeName="fillOpacity"
							from="1"
							to="1"
							begin="0s"
							dur="0.8s"
							values="1;.5;1"
							calcMode="linear"
							repeatCount="indefinite"
						/>
					</circle>
					<circle cx="60" cy="15" r="9" fillOpacity="0.3">
						<animate
							attributeName="r"
							from="9"
							to="9"
							begin="0s"
							dur="0.8s"
							values="9;15;9"
							calcMode="linear"
							repeatCount="indefinite"
						/>
						<animate
							attributeName="fill-opacity"
							from="0.5"
							to="0.5"
							begin="0s"
							dur="0.8s"
							values=".5;1;.5"
							calcMode="linear"
							repeatCount="indefinite"
						/>
					</circle>
					<circle cx="105" cy="15" r="15">
						<animate
							attributeName="r"
							from="15"
							to="15"
							begin="0s"
							dur="0.8s"
							values="15;9;15"
							calcMode="linear"
							repeatCount="indefinite"
						/>
						<animate
							attributeName="fill-opacity"
							from="1"
							to="1"
							begin="0s"
							dur="0.8s"
							values="1;.5;1"
							calcMode="linear"
							repeatCount="indefinite"
						/>
					</circle>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-warning"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M18.5 33.9167C27.0144 33.9167 33.9167 27.0144 33.9167 18.5C33.9167 9.98565 27.0144 3.08337 18.5 3.08337C9.98565 3.08337 3.08337 9.98565 3.08337 18.5C3.08337 27.0144 9.98565 33.9167 18.5 33.9167Z"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M18.5 12.3334V18.5"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M18.5 24.6666H18.5154"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-notification"
					viewBox="0 0 31 27"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M24.75 11.3334C24.75 8.88012 23.7754 6.52735 22.0407 4.79264C20.306 3.05792 17.9533 2.08337 15.5 2.08337C13.0467 2.08337 10.694 3.05792 8.95926 4.79264C7.22455 6.52735 6.25 8.88012 6.25 11.3334C6.25 22.125 1.625 25.2084 1.625 25.2084H29.375C29.375 25.2084 24.75 22.125 24.75 11.3334Z"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-check"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M33.9167 17.0817V18.5001C33.9148 21.8246 32.8383 25.0594 30.8478 27.7221C28.8572 30.3847 26.0593 32.3326 22.8712 33.2753C19.6832 34.2179 16.2758 34.1047 13.1574 32.9526C10.0389 31.8004 7.37638 29.6711 5.56694 26.8822C3.75749 24.0933 2.89805 20.7942 3.11679 17.4769C3.33553 14.1596 4.62073 11.0019 6.78072 8.47473C8.94071 5.94755 11.8598 4.18629 15.1025 3.45363C18.3452 2.72098 21.738 3.05618 24.7746 4.40924"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M33.9167 6.16663L18.5 21.5987L13.875 16.9737"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-cancel"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M18.5 33.9167C27.0144 33.9167 33.9167 27.0144 33.9167 18.5C33.9167 9.98565 27.0144 3.08337 18.5 3.08337C9.98565 3.08337 3.08337 9.98565 3.08337 18.5C3.08337 27.0144 9.98565 33.9167 18.5 33.9167Z"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M7.60046 7.60034L29.3996 29.3995"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-download"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M12.3333 26.2084L18.5 32.375L24.6666 26.2084"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M18.5 18.5V32.375"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M32.1901 27.8888C33.5304 26.9463 34.5355 25.6012 35.0596 24.0487C35.5836 22.4962 35.5994 20.8172 35.1045 19.2552C34.6096 17.6932 33.6298 16.3295 32.3074 15.3621C30.985 14.3946 29.3886 13.8737 27.7501 13.875H25.8076C25.3439 12.068 24.4764 10.3897 23.2702 8.96648C22.0641 7.54326 20.5508 6.41221 18.8442 5.65848C17.1377 4.90475 15.2824 4.54798 13.418 4.61502C11.5537 4.68207 9.72882 5.17119 8.08084 6.04555C6.43286 6.91992 5.00471 8.15674 3.9039 9.66292C2.80309 11.1691 2.05832 12.9054 1.72564 14.7411C1.39296 16.5767 1.48105 18.4639 1.98328 20.2606C2.48551 22.0573 3.38878 23.7167 4.62511 25.1138"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>

			<defs>
				<symbol
					id="icon-clock"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M18.5 33.9167C27.0144 33.9167 33.9166 27.0144 33.9166 18.5C33.9166 9.98565 27.0144 3.08337 18.5 3.08337C9.98559 3.08337 3.08331 9.98565 3.08331 18.5C3.08331 27.0144 9.98559 33.9167 18.5 33.9167Z"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M18.5 9.25V18.5L24.6667 21.5833"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-external-link"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M27.75 20.0417V29.2917C27.75 30.1094 27.4252 30.8937 26.8469 31.4719C26.2687 32.0501 25.4844 32.375 24.6667 32.375H7.70833C6.89058 32.375 6.10632 32.0501 5.52809 31.4719C4.94985 30.8937 4.625 30.1094 4.625 29.2917V12.3333C4.625 11.5156 4.94985 10.7313 5.52809 10.1531C6.10632 9.57485 6.89058 9.25 7.70833 9.25H16.9583"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M23.125 4.625H32.375V13.875"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M15.4167 21.5833L32.375 4.625"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>

			<defs>
				<symbol
					id="icon-help"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M18.5 33.9167C27.0144 33.9167 33.9166 27.0144 33.9166 18.5C33.9166 9.98565 27.0144 3.08337 18.5 3.08337C9.98559 3.08337 3.08331 9.98565 3.08331 18.5C3.08331 27.0144 9.98559 33.9167 18.5 33.9167Z"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M14.0137 13.875C14.3761 12.8447 15.0915 11.9759 16.0332 11.4224C16.9748 10.869 18.082 10.6667 19.1585 10.8514C20.235 11.036 21.2114 11.5957 21.9148 12.4313C22.6182 13.2669 23.0032 14.3245 23.0016 15.4167C23.0016 18.5 18.3766 20.0417 18.3766 20.0417"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M18.5 26.2084H18.5154"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>

			<defs>
				<symbol
					id="icon-file"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M20.0417 3.08337H9.25002C8.43227 3.08337 7.64801 3.40822 7.06977 3.98646C6.49154 4.5647 6.16669 5.34896 6.16669 6.16671V30.8334C6.16669 31.6511 6.49154 32.4354 7.06977 33.0136C7.64801 33.5919 8.43227 33.9167 9.25002 33.9167H27.75C28.5678 33.9167 29.352 33.5919 29.9303 33.0136C30.5085 32.4354 30.8334 31.6511 30.8334 30.8334V13.875L20.0417 3.08337Z"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M20.0417 3.08337V13.875H30.8334"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-document"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M21.5833 3.08337H9.24999C8.43224 3.08337 7.64798 3.40822 7.06974 3.98646C6.49151 4.5647 6.16666 5.34896 6.16666 6.16671V30.8334C6.16666 31.6511 6.49151 32.4354 7.06974 33.0136C7.64798 33.5919 8.43224 33.9167 9.24999 33.9167H27.75C28.5677 33.9167 29.352 33.5919 29.9302 33.0136C30.5085 32.4354 30.8333 31.6511 30.8333 30.8334V12.3334L21.5833 3.08337Z"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M21.5833 3.08337V12.3334H30.8333"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M24.6667 20.0416H12.3333"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M24.6667 26.2084H12.3333"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M15.4167 13.875H13.875H12.3333"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
			<defs>
				<symbol
					id="icon-special-arrow"
					viewBox="0 0 37 37"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M7.70837 18.5H29.2917"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M18.5 7.70837L29.2917 18.5L18.5 29.2917"
						stroke="currentColor"
						strokeWidth="2.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</symbol>
			</defs>
		</IconSheetContainer>
	);
};

export default IconSheet;
